.uic-thumbnail-item {
  align-items: center;
  background: var(--uic-color-white);
  border: 1px solid var(--uic-color-grey2);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: var(--uic-thumbnail-item-height, 48px);
  justify-content: center;
  margin: 8px;
  outline: 0;
  outline-offset: -2px;
  position: relative;
  user-select: none;
  width: var(--uic-thumbnail-item-width, 64px);

  @include focus-visible-outline() {
    outline: 2px solid var(--uic-color-blue2);
  }

  &:hover,
  &:active {
    border: 1px solid var(--uic-color-blue2);

    .uic-thumbnail-item__icon,
    uic-icon {
      color: var(--uic-color-blue3);
    }
  }

  &:active {
    background: var(--uic-color-blue2a10);

    > img,
    > svg {
      opacity: 0.5;
    }
  }

  > img,
  > svg {
    height: auto;
    max-height: 100%;
    max-width: 100%;
    width: auto;
  }

  uic-icon {
    color: var(--uic-color-grey3);
  }

  // use icon-bg as fallback to ensure correct white margin
  // with respect to the rest of the thumbnail item
  &__icon-bg {
    background: var(--uic-color-white);
    height: 22px;
    width: 24px;
  }

  &__icon,
  &__icon-bg {
    left: -8px;
    position: absolute;
    top: -10px;
  }

  &--placeholder uic-icon {
    color: var(--uic-color-grey6);
  }

  &.uic-thumbnail-item--selected {
    background: var(--uic-color-blue0a40);
    border: 1px solid var(--uic-color-blue2);
    box-shadow: 0 2px 8px 0 var(--uic-color-blue0a40);

    uic-icon {
      color: var(--uic-color-blue4);
    }
  }
}
